<template>
	<div class="right-page">
		<el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0px 20px;">
			<el-tab-pane :label="$t('委托订单')" name="1"></el-tab-pane>
			<el-tab-pane :label="$t('最新成交')" name="2"></el-tab-pane>
		</el-tabs>

		<div class="cont" v-if="activeName == 1">
			<!-- <div class="sas">
				<div class="s-itx siAs">
					<img src="@/assets/img-pc/icon2.png" class="qklx-img">
				</div>
				<div class="s-itx">
					<img src="@/assets/img-pc/icon3.png" class="qklx-img">
				</div>
				<div class="s-itx">
					<img src="@/assets/img-pc/icon4.png" class="qklx-img">
				</div>
			</div> -->
			<div class="list">
				<div class="item" v-for="(item, index) in asks" :key="`${index}asks`">
					<span>{{ item[1] }}</span>
					<span class="txt green">{{ item[0] }}</span>
				</div>
				<div class="line">
					<p class="green">{{ productInfo.price }}</p>
					<span class="txt-14" :class="[productInfo.price_zf > 0 ? 'green' : 'red']">
						{{ productInfo.price_zf }}%</span>
				</div>
				<div class="item" v-for="(item, index) in bids" :key="`${index}bids`">
					<span>{{ item[1] }}</span>
					<span class="txt red">{{ item[0] }}</span>
				</div>
			</div>
		</div>
		<div class="cont cont2" v-if="activeName == 2">
			<div class="dis-fle ali-cen jus-bet" v-for="(item, index) in orderList" :key="`${index}order`">
				<span class="">{{ item.createtime }}</span>
				<span :class="randomBool() ? 'red' : 'green'">{{ item.amount }}</span>
				<span class="">{{ item.open_price }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import { get } from '@/http/request'
export default {
	props: {
		productInfo: {
			type: Object,
			default: () => { }
		},
	},
	data() {
		return {
			activeName: '2',

			orderList: [],

			asks: [],
			bids: [],
		};
	},
	computed: {
	},
	methods: {
		handleClick() { },
		randomBool(p = 0.5) {  // 默认 50%
			return Math.random() < p
		},
		init(data) {
			this.getProductDepth(data)
			this.recentOrder(data)
		},
		getProductDepth({
			label, code
		}) {
			get(this.$apis.getProductDepth, {
				showLoading: false,
				label,
				code
			}).then(res => {
				if (res.code != 1) return
				const data = res.data[0] || {}
				this.asks = data.asks || []
				this.bids = data.bids || []
			})
		},
		recentOrder({ product_id }) {
			get(this.$apis.recentOrder, {
				showLoading: false,
				product_id
			}).then(res => {
				if (res.code != 1) return
				this.orderList = res.data
			})
		}
	},
};
</script>
<style lang="scss" scoped>
.right-page {
	width: 300px;

	.cont {
		padding: 17px 32px 32px;

		&.cont2 {
			padding: 16px;

			.dis-fle {
				line-height: 32px;
			}
		}

		.list {
			font-size: 12px;
			text-align: center;

			.item {
				margin-bottom: 16px;
				font-size: 14px;
				color: #7e7e7e;

				span {
					width: 50%;
					display: inline-block;
					text-align: left;
					color: #fff;

					&.txt {
						text-align: right;
					}
				}
			}

			.line {
				// line-height: 40px;
				text-align: left;
				font-size: 16px;
				margin-bottom: 16px;
				margin-top: 5pxF;
			}

		}

		.green {
			color: #00f0ff !important;
		}

		.red {
			color: #ff4834 !important;
		}

		.sas {
			display: flex;
			margin-bottom: 16px;

			.s-itx {
				margin-right: 16px;
				cursor: pointer;

				img {
					width: 32px;
					height: 34px;
				}

				&.siAs {
					img {
						border: 1px solid #fff;
					}
				}
			}
		}
	}
}
</style>